// A place for legacy routes to live, with redirections to their
// actively maintained counterparts (or another suitable page)

import { RouteRecordRaw } from 'vue-router'

const redirects: Array<RouteRecordRaw> = [
  {
    path: '/resilience101',
    redirect: { name: 'landing' }
  },
  {
    path: '/primer',
    redirect: { name: 'landing' }
  },
  {
    path: '/admin/users/create',
    redirect: () => {
      return { name: 'users-overview' }
    }
  },
  {
    path: '/admin/workshops/:uuid/sketches/effects/:sketchid?',
    redirect: (to) => {
      return { path: to.path.replace(/(?:\/admin|\/effects)/gi, '') }
    }
  },
  {
    path: '/admin/:pathMatch(.*)*',
    redirect: (to) => {
      return { path: to.path.replace('/admin', '') }
    }
  },
  {
    path: '/workshops/:uuid/:pathMatch(.*)*',
    redirect: (to) => {
      return { name: 'select-tool', params: { uuid: to.params.uuid } }
    }
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: () => {
      return { name: 'user-view' }
    }
  }
]

export default redirects
